var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMedical = function SvgIconMedical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.16 512.16",
    height: 512,
    viewBox: "0 0 512.16 512.16",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256.08,
    cy: 256.08,
    fill: "#ff4a4a",
    r: 256.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.543 0v512.148c141.215-.251 255.617-114.8 255.617-256.074s-114.401-255.823-255.617-256.074z",
    fill: "#e20059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.074 191.459h-70.641c-2.455 0-4.445-1.99-4.445-4.445v-70.641c0-7.922-6.422-14.343-14.343-14.343h-100.204c-7.922 0-14.343 6.422-14.343 14.343v70.641c0 2.455-1.99 4.445-4.445 4.445h-70.641c-7.922 0-14.343 6.422-14.343 14.343v100.204c0 7.922 6.422 14.343 14.343 14.343h70.641c2.455 0 4.445 1.99 4.445 4.445v70.64c0 7.922 6.422 14.343 14.343 14.343h100.204c7.922 0 14.343-6.422 14.343-14.343v-70.64c0-2.455 1.99-4.445 4.445-4.445h70.641c7.922 0 14.343-6.422 14.343-14.343v-100.203c0-7.922-6.421-14.344-14.343-14.344z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.074 191.459h-70.641c-2.455 0-4.445-1.99-4.445-4.445v-70.641c0-7.922-6.422-14.343-14.343-14.343h-50.102v307.748h50.102c7.922 0 14.343-6.422 14.343-14.343v-70.64c0-2.455 1.99-4.445 4.445-4.445h70.641c7.922 0 14.343-6.422 14.343-14.343v-100.204c0-7.922-6.421-14.344-14.343-14.344z",
    fill: "#f4f1f1"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMedical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-medical.bc0ed20b.svg";
export { ForwardRef as ReactComponent };